import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { CartContext } from '../../contexts/CartContext';

export const ContinueToReview = () => {
    const { setSubmitCreditCard } = useContext(CartContext);
    const { t } = useTranslation();

    const continueToReview = () => {
        setSubmitCreditCard('create');
    };

    return (
        <div className="placeorder__wrap button--sticky gotoPlaceOrder">
            <button
                className="button placeorder__button--black"
                onClick={continueToReview}
                data-link-type="cta button"
                data-link-title="continue to review"
                data-component-type="express checkout"
            >
                <span>{t('Continue To Review')}</span>
            </button>
        </div>
    );
};
